module.exports = __webpack_public_path__ + "img/grafikaNaCoDzienBackPage.59f36181.png";